import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiPython,
  DiGit,
  DiHtml5,
  DiCss3,
  DiMysql,
  DiAngularSimple,
  DiLaravel,
  DiPhp,
  DiDart,
} from "react-icons/di";
import { IoLogoElectron, IoLogoGithub, IoLogoIonic } from "react-icons/io5";
import { SiTypescript, SiFlutter, SiPostgresql, SiPerforce } from "react-icons/si";
import { FaGitlab } from "react-icons/fa";

/**
 * Reusable wrapper for one icon + tooltip.
 * No TypeScript types needed (this is pure JS).
 */
function TechIcon({ label, children }) {
  return (
    <Col xs={4} md={2} className="tech-icons">
      <OverlayTrigger
        placement="top"
        delay={{ show: 120, hide: 80 }}
        overlay={<Tooltip id={`tooltip-${label}`}>{label}</Tooltip>}
      >
        {/* span is important because OverlayTrigger needs a single child */}
        <span
          tabIndex={0}
          style={{ display: "inline-flex", cursor: "default" }}
          aria-label={label}
        >
          {children}
        </span>
      </OverlayTrigger>
    </Col>
  );
}

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <TechIcon label="HTML5"><DiHtml5 /></TechIcon>
      <TechIcon label="CSS3"><DiCss3 /></TechIcon>
      <TechIcon label="MySQL"><DiMysql /></TechIcon>
      <TechIcon label="PostgreSQL"><SiPostgresql /></TechIcon>
      <TechIcon label="TypeScript"><SiTypescript /></TechIcon>
      <TechIcon label="JavaScript"><DiJavascript1 /></TechIcon>
      <TechIcon label="PHP"><DiPhp /></TechIcon>
      <TechIcon label="Python"><DiPython /></TechIcon>
      <TechIcon label="Dart"><DiDart /></TechIcon>
      <TechIcon label="Angular"><DiAngularSimple /></TechIcon>
      <TechIcon label="Laravel"><DiLaravel /></TechIcon>
      <TechIcon label="Flutter"><SiFlutter /></TechIcon>
      <TechIcon label="React"><DiReact /></TechIcon>
      <TechIcon label="Electron"><IoLogoElectron /></TechIcon>
      <TechIcon label="Ionic"><IoLogoIonic /></TechIcon>
      <TechIcon label="Node.js"><DiNodejs /></TechIcon>
      <TechIcon label="Git"><DiGit /></TechIcon>
      <TechIcon label="GitLab"><FaGitlab /></TechIcon>
      <TechIcon label="GitHub"><IoLogoGithub /></TechIcon>
      <TechIcon label="Perforce"><SiPerforce /></TechIcon>
    </Row>
  );
}

export default Techstack;
